export class LogbogSpecialespecifikkeFilerRequestModel {
    constructor(regionId: string, maalbeskrivelseId: string | undefined) {
        this.regionId = regionId;
        this.maalbeskrivelseId = maalbeskrivelseId;
    }
    public regionId: string;
    public maalbeskrivelseId?: string;
}
